const BASE_API = process.env.MIX_ENDLESS_API_URL

const state ={
	languageSchoolsList:[],
	languageSchoolsListData:[],
	languageSchoolsMeta:[],
	languageSchoolById:'',
	campusCourses:[],
	course:'',
	accommodations:[],
	courseSubjects:[],
	nearPlaces:[],
	languageSchoolsListError:null,
	languageSchoolsCoursesError:null,
	languageSchoolsAccommodationsError:null
}
const getters = {
	languageSchoolsListGetter:({languageSchoolsList}) => languageSchoolsList,
	languageSchoolsMetaGetter:({languageSchoolsMeta}) => languageSchoolsMeta,
	languageSchoolByIdGetter:({languageSchoolById}) => languageSchoolById,
	languageSchoolsListData:({languageSchoolsListData}) => languageSchoolsListData,
	campusCoursesGetter:({campusCourses}) => campusCourses,
	courseGetter:({course}) => course,
	campusAccommodationsGetter:({accommodations}) => accommodations,
	campusCourseSubjectsGetter:({courseSubjects}) => courseSubjects,
	nearPlacesGetter:({nearPlaces}) => nearPlaces,
}

const mutations = {
	setLanguageSchoolsList : (state,payload)=> {
		state.languageSchoolsList = payload
	},
	setLanguageSchoolsMeta : (state,payload)=> state.languageSchoolsMeta = payload,
	setLanguageSchoolsListSeeMore : (state,payload)=> state.languageSchoolsListData.push(...payload),
	setEmptyLanguageSchoolsListData : (state,payload)=> state.languageSchoolsListData = [],
	setLanguageSchoolById: (state,payload)=> state.languageSchoolById = payload,
	setCampusCourses : (state,payload)=> state.campusCourses = payload,
	setCourse:(state,payload) => state.course = payload,
	setNearPlaces:(state,payload) => state.nearPlaces = payload,
	setCampusAccommodations : (state,payload)=> state.accommodations = payload,
	setCampusCourseSubjects : (state,payload)=> state.courseSubjects = payload,
	setFavorite:(state,payload) => {
		const findSchool = state.languageSchoolsList.find(school => school.id === payload.campus_id)
		findSchool.is_favorite = payload.favorite
	},
	setFavoriteDetail:(state,payload) => {
		state.languageSchoolById.campus.is_favorite = payload.favorite
	},
}

const actions = {
	async getLanguageSchoolsList({commit,state}, payload){
		await this.$axios.get(`${BASE_API}/campuses`,{params:{...payload.filters},headers:{...payload.headers}}).then(res => {
			commit('setLanguageSchoolsList',res.data.result.data)
			commit('setLanguageSchoolsMeta',res.data.result.meta)
		}).catch(err => {
			if (err.response.status === 404) window.location.href = '/404';
			state.languageSchoolsListError = err.response.status
		})
	},
	async searchCampuses({commit}, payload){
		await this.$axios.get(`${BASE_API}/search/campuses`,{params:{...payload.filters},headers:{...payload.headers}}).then(res => {
			commit('setLanguageSchoolsList',res.data.result.data)
		})
	},
	async getLanguageSchoolById({commit}, payload){
		var params = {place_id: payload.placeId}
		await this.$axios.get(`${BASE_API}/campuses/${payload.slug}`,{params: params}).then(res => {
			commit('setLanguageSchoolById',res.data.result)
		}).catch(err =>{
			if (err.response.status === 404) window.location.href = '/404';
			state.languageSchoolsListError = err.response.status
		} )
	},
	async getNearPlaces({commit}, payload){
		var params={
			lat:payload.lat,
			lng:payload.lng,
		}
		await this.$axios.get(`${BASE_API}/nearby-places`,{params}).then(res => {
			commit('setNearPlaces',res.data.result)
		})
	},
	async getCampusCourses({commit}, payload){
		var params = {...payload.filters, place_id: payload.placeId}
		commit('setCampusCourses',[])
		if(payload.headers['accept-school-type']) {
			this.$axios.defaults.headers['Accept-School-Type'] = payload.headers['accept-school-type']
		}
		await this.$axios.get(`${BASE_API}/campuses/${payload.slug}/courses`,{params: params}).then(res => {
			commit('setCampusCourses',res.data.result)
		}).catch(err => state.languageSchoolsCoursesError = err.response.status)
	},
	async getCourse({commit}, payload){
		if(payload.headers['accept-school-type']) {
			this.$axios.defaults.headers['Accept-School-Type'] = payload.headers['accept-school-type']
		}
		await this.$axios.get(`${BASE_API}/courses/${payload.courseId}`).then(res => {
			commit('setCourse',res.data.result)
		}).catch(err => {
			if (err.response.status === 404) window.location.href = '/404';
			state.languageSchoolsListError = err.response.status
		}
		)
	},
	async getCampusAccommodations({commit}, payload){
		var params = {...payload.params, place_id: payload.placeId}
		await this.$axios.get(`${BASE_API}/campuses/${payload.slug}/accommodations`, {params: params}).then(res => {
			commit('setCampusAccommodations',res.data.result)
		}).catch(err => state.languageSchoolsAccommodationsError = err.response.status)
	},
	async getCampusCourseSubjects({commit}, payload){
		var params = {place_id: payload.placeId}
		await this.$axios.get(`${BASE_API}/campuses/${payload.slug}/course-subjects`, {params: params}).then(res => {
			commit('setCampusCourseSubjects',res.data.result.data)
		}).catch(err => {
			if (err.response.status === 404) window.location.href = '/404';
			state.languageSchoolsListError = err.response.status
		})
	},
}

export default {namespaced:true,state,getters,mutations,actions}
